import React,{useState,useEffect} from "react";
import {getStudentIdData } from "../../../../lib/studentgradeinmonthlistview"
import { getStudentIdWithClassData as getStudentLessons } from "../../../../lib/studentlessonsview"
import {getIdData } from "../../../../lib/studentinfo"
import GradeCell from "./gradecell";
import style from "./gradelist.module.css"


export default function GradeList({slug}) {

    const [studentGradeList, setStudentGradeList] = useState();
    const [studentInfo, setStudentInfo] = useState();
    const [studentLessons, setStudentLessons] = useState();
    const [monthList, setMonthList] = useState([
      "September",
      "October",
       "November",
       "December",
       "January",
       "February",
       "March",
       "April",
       "May",
       "June"
  ])
  
    async function GetData() {
      const info = await getStudentIdData(slug);
      setStudentGradeList(info);

      const sclass = await getIdData(slug);
      setStudentInfo(sclass[0].class);

      const lessons = await getStudentLessons(slug,sclass[0].class);
      setStudentLessons(lessons);
    }
  
  useEffect(() => {
    GetData();
  }, [])
  

  function GetGradeColor(grade) {
    let color = "#FF0000";

    if (grade > 0 && grade < 65) color = '#FF0000'
    if (grade > 64 && grade < 71)  color = "#FFA500";
    if (grade > 70 && grade < 81)  color = "#FFFF00";
    if (grade > 80 && grade < 91)  color = "#32CD32";
    if (grade > 90)  color = "#1E90FF";

return `{style={{backgroundColor:${color}}}}`;

  }

  function GetGrade(monthName,lessonId) {
  
    const result = studentGradeList.filter((grades) => {
      return grades.month === monthName && grades.lesson === lessonId;
    });
  
    //console.log("result",result);
    if (result.length > 0)
       return result[0].grade;
    else
    return "-";
  }

  return (
    <div className="settings-widget">
    <div className="settings-inner-blk p-0">
      <div className="p-3">
  <div className="personal-info-head">
    <h4 className="goal_settings_title">Current Grades</h4>
  </div>
  <div className="pb-0">
        <div className="settings-referral-blk course-instruct-blk  table-responsive ">
          {/* Instructor Users */}
<div style={ {overflowX: "auto"}} className="currentGrades_table">
          <table className={`${style.gradeListTable} table table-striped mb-0 table-hover w-100 table-bordered`}>
            <thead>
              <tr className="currentGrades_head_part">
                <th></th>
                {studentLessons ? studentLessons.map(function (less) {
        return (
          <>
                <th key = {less.id} className="text-center">
                  <p className="fs-6">{` ${less.pname} `}</p>
                  <p></p>
                  <p className="fs-6 fw-normal"><>{less.lessonName}</></p></th>
                </>
                )
              })  : ""}
              {/* <th></th> */}
              </tr>
            </thead>
            <tbody>
            {monthList.map(function (data,ix) {
        return (
              <tr key = {ix}>
                <td className="fs-6 fw-bold">
                &nbsp; {data}
                </td>
                {studentLessons ? studentLessons.map(function (less) {
                return (
                  <>
                         <GradeCell grade={GetGrade(data,less.id)} key={less.id}/>
                        </>
                        )
                      })  : ""}
                {/* <td></td> */}
              </tr>
                )
              })  }
            </tbody>
          </table>
          </div>
          {/* Instructor List */}
        </div>
      </div>
</div>
    </div>
  </div>
  )
}
